export default __webpack_public_path__ + "static/media/logo-us-coach.1065025d.svg";